import { createAsyncThunk } from "@reduxjs/toolkit";
import { setWidgetSetup } from "../../../../dashboardsSlice";
import { RootState } from "@/store/store";
import { currentDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/currentDashboardIdSelector";
import { dashboardDatesByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDatesByDashboardIdSelector";
import { costAnomaliesSetupSelector } from "@/store/dashboards/selectors/setups/cost-anomalies/costAnomaliesSetupSelector";
import { costAnomaliesSetupChangeThunk } from "@/store/dashboards/thunks/widgets/cost-anomalies/widget-change/costAnomaliesSetupChangeThunk";

export const costAnomaliesInheritanceChangeThunk = createAsyncThunk(
  "dashboards/costAnomaliesInheritanceChange",
  async (inheritDates: boolean, { dispatch, getState }) => {
    const state = getState() as RootState;
    const existingSetup = costAnomaliesSetupSelector(state);
    const dashboardId = currentDashboardIdSelector(state) ?? "";

    if (!existingSetup || !dashboardId) {
      return;
    }

    const dashboardDate = dashboardDatesByDashboardIdSelector(
      state,
      dashboardId,
    );

    if (!dashboardDate) {
      return;
    }

    dispatch(setWidgetSetup({ ...existingSetup, inheritDates }));
    dispatch(costAnomaliesSetupChangeThunk({ dates: dashboardDate }));
  },
);
